<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Carga de inventário por planilha
      </p>
      <div>
        <router-link
          :to="{
            name: 'inventario-listar',
          }"
        >
          <div
            style="cursor: pointer"
            class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" color="brand-5" />
            <span style="font-size: 20px">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>

    <infot-upload
      :activeSlide="activeSlide"
      :link="'https://multpex-docs.s3.amazonaws.com/templates/inventario/modelo_para_inventario_por_planilha_r0.xlsx'"
      :infos="infos"
    />

    <upload-planilha-layout
      titulo="Enviar planilha de inventário"
      :file="file"
      :is-drag-over="isDragOver"
      :submit-disabled="!file"
      submit-label="Enviar Template"
      @drag-over="isDragOver = true"
      @drag-leave="isDragOver = false"
      @drop-file="onDrop"
      @file-selected="onFileSelected"
      @instructions="activeSlide = !activeSlide"
      @submit="enviarTemplate"
    />
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
import UploadPlanilhaLayout from "../../../../components/UploadPlanilhaLayout.vue";

import { useRouter } from "vue-router";
export default {
  components: { InfotUpload, UploadPlanilhaLayout },
  setup() {
    const quasar = useQuasar();
    const store = useStore();
    const router = useRouter();
    const file = ref(null);
    const isDragOver = ref(false);
    const activeSlide = ref(false);
    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Não crie nenhuma outra coluna",
        icon: "delete",
      },
      {
        name: "APAGUE as informações da linha 2 em diante e preencha com seus valores reais",
        icon: "view_column",
      },
      {
        name: "Se houver erro de digitação da coluna A (código) a linha será ignorada.",
        icon: "do_not_disturb",
      },
      {
        name: " Somente as colunas A e B são obrigatórias para todos os itens, para itens com controle de lote, as colunas C e E passam a ser obrigatórias também",
        icon: "event",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "event",
      },
    ]);

    const onFileSelected = (e) => {
      if (e.target.files[0]) file.value = e.target.files[0];
    };

    const onDrop = (e) => {
      isDragOver.value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        file.value = f;
      } else {
        quasar.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const enviarTemplate = async () => {
      if (!file.value || !file.value.name.endsWith(".xlsx")) {
        quasar.notify({
          message: "O tipo do arquivo não e aceito, ou o campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            await store.dispatch("estoque/upload", {
              planilha: reader.result,
              mapeamento: "inventario",
              adicional: { vendor_id: store.state.org.unidadeData.id },
            });

            quasar.notify({
              message: "Planilha enviada com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            router.push({ name: "inventario-listar" });
          } catch (error) {
            quasar.notify({
              message: "Erro a o enviar planilha",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        };

        file.value = "";
      } catch (error) {
        console.log(error);

        file.value = "";
      }
    };

    return {
      enviarTemplate,
      file,
      isDragOver,
      activeSlide,
      infos,
      onFileSelected,
      onDrop,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.container-link-voltar {
  margin-right: 10px;
}
</style>
